/* tslint:disable:typedef-whitespace no-trailing-whitespace no-inferrable-types import-spacing */

import {ElementRef} from '@angular/core';

import {Dialog} from './dialog';
import {Logger} from '../../util/logger';
import {IValidatorCallBack} from './i.validator.call.back';
import {IOkCallBack} from './i.ok.call.back';
import {BlobType, Blob} from '../../models/blob';

import * as $ from 'jquery';
import 'jquery-ui-dist/jquery-ui';
import {createPopper} from '@popperjs/core';


/**
 *
 * @class NewEmptyBlobDialog
 *
 * @brief dialog for selecting name/type of new (but empty) blob to add as an input (can be
 * edited later)
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class NewEmptyBlobDialog extends Dialog {

  /** the name we're trying get from the user */
  private name: string = '';

  /** the type of the blob */
  private type: BlobType = BlobType.Scenario;

  /** the kinds of blobs we are allowing */
  private allowed: BlobType[] = [BlobType.Scenario, BlobType.Plant, BlobType.Traffic];

  /** timer to wait for user to stop typing */
  private typingTimer = null;

  /** standard constructor, allow for partial alert to be given */
  constructor(
    host: ElementRef
  ) {

    super(host);

    this.title = 'New empty Blob';
    this.icon  = '<i class="fas fa-plus"></i>';

    Logger.debug('[NewEmptyBlobDialog] setting up...');
  }

  /** dialog has been opened */
  public open(validator?: IValidatorCallBack, success?: IOkCallBack, options?: any) {

    this.validator          = validator ? validator : null;
    this.success            = success   ? success   : null;

    let placeholder: string = '';
    let types: BlobType[]   = [];

    if (options) {

      if (options.placeholder) {

        placeholder = options.placeholder;
      }

      if (options.types) {

        if (options.types.length > 0) {

          types = options.types;
          this.type = types[0];
        }
      }
    }

    if (this.typingTimer) {

      clearTimeout(this.typingTimer);

      this.typingTimer = null;
    }

    Logger.debug('[NewEmptyBlobDialog] opening...');

    this.name       = '';
    this.type      = BlobType.Scenario;

    if (types.length > 0) {

      this.type = types[0];
    }

    const body     = $(this.host).find('.modal-body');

    let typePick = `<div class="control gui-radio-toolbar">

  <input class="empty-blob-kind" id="scenario-empty-blob" type="radio" name="type"  value="scenario" checked>
  <label for="scenario-empty-blob" class="radio" style="margin-right: 12px;">
    <img src="assets/images/blob-icons/blob-scenario-20.png" style="margin-right: 8px;">Scenario
  </label>

  <input class="empty-blob-kind" id="plant-empty-blob" type="radio" name="type"  value="plant">
  <label for="plant-empty-blob" class="radio" style="margin-right: 12px;">
    <img src="assets/images/blob-icons/blob-plant-20.png" style="margin-right: 8px;">Plant
  </label>

  <input class="empty-blob-kind"  id="traffic-empty-blob" type="radio" name="type"  value="traffic">
  <label for="traffic-empty-blob" class="radio">
    <img src="assets/images/blob-icons/blob-traffic-20.png" style="margin-right: 8px;">Traffic
  </label>

</div>`;

    if (types.length > 0) {

      /* general set of types was provided */

      typePick = `<div class="dropmenu new-empty-type-inputs no-highlight" style="">`;

      typePick += `<div id="new-empty-type-inputs" class="control gui-radio-toolbar" aria-describedby="tooltip">
  <input class="empty-blob-kind" id="general-type-empty-blob" type="radio" name="type"  value="` +
        Blob.stringOfType(types[0]) +
        `" checked>
  <label id="new-empty-type-input-label" for="general-type-empty-blob" class="radio" style="margin-right: 12px; display: inline-block; margin-left: 8px;">
    <img src="assets/images/blob-icons/`;

      typePick += Blob.iconOfType(types[0]);

      typePick += `" style="margin-right: 8px;">`;

      typePick += Blob.stringOfType(types[0]);

      typePick += `</label>`;


      typePick += `<div class="dropmenu-down-content" style="padding: 0; width: 300px;">`;

      types.forEach((value: BlobType) => {

        typePick += `<label class="gui-button new-empty-type-click" type="`;
        typePick += Blob.stringOfType(value);
        typePick += `" style="display: inline-block; margin: 4px;"><img src="assets/images/blob-icons/`;
        typePick += Blob.iconOfType(value);
        typePick += `" style="margin-right: 8px;">`;
        typePick += Blob.stringOfType(value);
        typePick += `  </label>`;

      });

      typePick += `<div style="clear: both; height: 1px;"></div></div></div>`;

      typePick += `</div>`;


    }

    const html = `
${typePick}
<div style="clear: both; margin-top: 12px;">
<label class="gui-label">Name:</label>
<input class="gui-input empty-blob-name-input" type="text" placeholder="${placeholder}">
</div>
<div class="gui-error-line"></div>
    `;

    $(body).html(html);

    /* add behaviors */

    setTimeout(() => {

      $(this.host).find('.empty-blob-name-input').focus();

      $('.new-empty-type-click').on('click', (e) => {

        $('input.empty-blob-kind').val($(e.currentTarget).attr('type'));

        const type: BlobType = Blob.typeofString($(e.currentTarget).attr('type') as string);

        $('#new-empty-type-input-label').html(`<img src="assets/images/blob-icons/` +
          Blob.iconOfType(type) +
          `" style="margin-right: 8px;">` +
          Blob.stringOfType(type)
        );

        this.type = type;

      });

      $('input.empty-blob-kind[type=radio][name=type]').on('input', (e) => {

        this.type = Blob.typeofString($(e.currentTarget).val() as string);

        this.validate();
      });

      $(this.host).find('.empty-blob-name-input').on('input', (e) => {

        /* typing wait: @link https://stackoverflow.com/questions/10124114/wait-for-function-till-user-stops-typing */

        if (this.typingTimer) {

          clearTimeout(this.typingTimer);
        }

        this.typingTimer = setTimeout(() => {

          this.name = ($(e.currentTarget).val() as string).trim();

          this.validate();

        }, 400);

      });

      $(this.host).find('.empty-blob-name-input').on('keypress', (e) => {

        if (this.typingTimer) {

          clearTimeout(this.typingTimer);
        }

        this.typingTimer = setTimeout(() => {

          this.name = ($(e.currentTarget).val() as string).trim();

          if (e.key.toLowerCase() === 'enter') {

            this.validate(true);

            /* stop event propagation */

            return false;
          }

        }, 400);

      });

    }, 50);

    /* disable the Ok button...until we have valid input */

    this.validate();
  }

  disable() {

    const ok = $(this.host).find('.modal-ok-button');

    $(ok).attr('disabled', 'true');
    $(ok).addClass('disabled');
  }

  enable() {

    const ok = $(this.host).find('.modal-ok-button');

    $(ok).removeAttr('disabled');
    $(ok).removeClass('disabled');

  }

  /** show a validation error */
  error(msg: string) {

    const display = $(this.host).find('.gui-error-line');

    $(display).html(msg);
  }

  /* don't enable the Ok button until we have what we need. */
  validate(transition: boolean = false) {

    this.error('');

    /* assume its bad */

    this.disable();

    if (!this.validator) {

      /* at least make sure the name is't empty */

      if (this.name === '') {

        this.error('Blob name can not be empty.');

        return ;
      }

      if (this.allowed.find(x => x === this.type)) {

        this.error('Unknown kind of input: ' + Blob.stringOfType(this.type));

        return ;
      }

      this.enable();

      /* if we make it through validation checks, and we're allowed to transition, then do it. */

      if (transition) {

        /* click the ok button for them, and trigger via ModelComponent */

        const ok = $(this.host).find('.modal-ok-button');

        $(ok).click();
      }

    } else {

      /* wrap validation in a promise, so its ok if its asynchronous */

      const p = new Promise((resolve, reject) => {

        this.validator({name: this.name, type: this.type}, resolve, reject);

      }).then((data: any) => {

        this.name = data.name as string;
        this.type = data.type as BlobType;

        this.enable();

        if (transition) {

          /* click the ok button for them, and trigger via ModelComponent */

          const ok = $(this.host).find('.modal-ok-button');

          $(ok).click();
        }

      }).catch((error) => {

        /* show the validation error */

        this.error(error);

      });

    }

  }

  /** dialog is closing */
  public close() {

    Logger.debug('[NewEmptyBlobDialog] closing...');
  }

  /** dialog was accepted */
  public ok() {

    Logger.debug('[NewEmptyBlobDialog] accepted: ', this.name);

    if (this.success) {

      /* inform the client */

      this.success( {name: this.name, type: this.type});
    }

  }
}


